import { nostToOst } from "../utils/utils";
import { Row } from "./tableComponents";

type props = {
    denom: string,
    amount: string,
}

const DenomRow = ({denom, amount} : props) => {

    let symbol: string = denom;
    let amountPresentation: string = amount;
    if(symbol === "nost"){
        symbol = "ost";
        amountPresentation = `${nostToOst(amount)}`
    }
    return <Row field={symbol.toUpperCase()} remBorder={true} value={amountPresentation}/>
}

export default DenomRow
